import { SwapOfferCreateTxParams, SwapOfferSwapADAxFTTxParams, SwapOfferSwapFTxADATxParams, toJson, WalletTxParams } from '../../Commons';
import { SwapOfferEntity } from '../../Entities/SwapOffer.Entity';
import { SmartDBTxApiCalls } from '../index.exports.BtnHandlers.TxApiCalls';
import { fetchWrapper } from '../../lib/index.exports';

export class SwapOfferTxApiCalls extends SmartDBTxApiCalls {
    protected static _Entity = SwapOfferEntity;

    // #region api tx

    public static async createTxApi(walletTxParams: WalletTxParams, txParams: SwapOfferCreateTxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `SwapOfferCreateTxParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/create`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - createTxApi - OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - createTxApi - Error: ${error}`);
            throw error;
        }
    }

    public static async swapFTxADATxApi(walletTxParams: WalletTxParams, txParams: SwapOfferSwapFTxADATxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `SwapOfferSwapFTxADATxParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/swap-ft-x-ada`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - swapFTxADATxApi - OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - swapFTxADATxApi - Error: ${error}`);
            throw error;
        }
    }

    public static async swapADAxFTTxApi(walletTxParams: WalletTxParams, txParams: SwapOfferSwapADAxFTTxParams): Promise<any> {
        try {
            if (txParams === undefined) {
                throw `SwapOfferSwapADAxFTTxParams not defined`;
            }
            const body = toJson({ walletTxParams, txParams });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${this._Entity.apiRoute()}/tx/swap-ada-x-ft`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${this._Entity.apiRoute()}] - swapADAxFTTxApi - OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${this._Entity.apiRoute()}] - swapADAxFTTxApi - Error: ${error}`);
            throw error;
        }
    }

    // #endregion api tx
}
